export const BannerVariant = {
  Info: 'info',
  Warning: 'warning',
  Danger: 'danger',
  Success: 'success',
  Pending: 'pending',
} as const;

export type BannerVariantType =
  (typeof BannerVariant)[keyof typeof BannerVariant];
